module.exports = __webpack_public_path__ + "img/log-out.15db6917.svg";